import styled from 'styled-components';

import { mediaTopBarVisible, mediaTopBarHidden } from '@xing-com/layout-tokens';
import { Marker } from '@xing-com/marker';
import { spaceL, spaceXXL, spaceS } from '@xing-com/tokens';

export const StyledProductsMenuWrapper = styled.div`
  @media (width <= 1112px) {
    display: none;
  }
`;

const StyledActionsContainer = styled.div`
  display: flex;
  align-items: center;

  /* stylelint-disable-next-line media-query-no-invalid */
  @media ${mediaTopBarHidden} {
    gap: ${spaceS};
  }

  @media (width >= 1428px) {
    gap: ${spaceL};
  }

  @media (width >= 1572px) {
    gap: ${spaceXXL};
  }
`;

export const ActionButtonSpace = styled.div`
  padding: ${spaceS};
`;

export const ButtonWithMarkerContainer = styled(ActionButtonSpace)`
  position: relative;
`;

export const StyledMarker = styled(Marker)`
  position: absolute;
  bottom: -4px;
  right: -5%;
  padding: 0 ${spaceS};
`;

export const StyledOnlyOnBigScreenContainer = styled(StyledActionsContainer)`
  /* stylelint-disable-next-line media-query-no-invalid */
  @media ${mediaTopBarVisible} {
    display: none;
  }
`;

export const StyledOuterActionsContainer = styled(StyledActionsContainer)`
  margin-right: calc(-1 * ${spaceS});
`;
